export default "__VITE_ASSET__L2sLHAfq__"